import type React from 'react';
import OrbitalDiagram from './OrbitalDiagram';
import OrbitalShapes from './OrbitalShapes';
import EnergyLevels from './EnergyLevels';
import EnergyProfile from './EnergyProfile';
import PeriodicTrends from './PeriodicTrends';
import BondingContinuum from './BondingContinuum';
import MoleMap from './MoleMap';
import PhIndicator from './PhIndicator';
import IsotopeNotation from './IsotopeNotation';
import ReactionParticles from './ReactionParticles';
import ConcentrationView from './ConcentrationView';
import LewisDots from './LewisDots';
import SolubilityCurve from './SolubilityCurve';
import SkeletalStructure from './SkeletalStructure';
import ReactionConditions from './ReactionConditions';
import GoldFoilExperiment from './GoldFoilExperiment';

// RICH cluster — deeper, more detailed teaching visuals built to strengthen the
// course (orbital energy diagrams, periodic trends, reaction energy profiles, …).
// Registered by `type` string for the WidgetRenderer's default-case dispatch.
export const RICH_WIDGETS: Record<
  string,
  React.ComponentType<{ config: any; onComplete?: () => void; cue?: any }>
> = {
  orbital_diagram: OrbitalDiagram,
  orbital_shapes: OrbitalShapes,
  energy_levels: EnergyLevels,
  energy_profile: EnergyProfile,
  periodic_trends: PeriodicTrends,
  bonding_continuum: BondingContinuum,
  mole_map: MoleMap,
  ph_indicator: PhIndicator,
  isotope_notation: IsotopeNotation,
  reaction_particles: ReactionParticles,
  concentration_view: ConcentrationView,
  lewis_dots: LewisDots,
  solubility_curve: SolubilityCurve,
  skeletal_structure: SkeletalStructure,
  reaction_conditions: ReactionConditions,
  gold_foil: GoldFoilExperiment,
};
